// extracted by mini-css-extract-plugin
export var logo = "_5f-2";
export var logoWrapper = "_5f-1";
export var strip = "_5f-0";